import { cn } from "@/lib/utils";
import { useDraggable } from "@dnd-kit/core";

type Props = {
  children: React.ReactNode;
  id: string;
  left: string;
  top: string;
  height: number;
  width: number;
};

function Draggable(props: Props) {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: props.id,
      data: {
        id: props.id,
        left: props.left,
        top: props.top,
        height: props.height,
        width: props.width,
      },
    });

  return (
    <div
      ref={setNodeRef}
      className={cn(
        "absolute hover:z-30 z-1 text-center touch-none",
        isDragging && "opacity-50",
      )}
      style={{
        transform:
          transform && !isDragging
            ? `translate3d(${transform.x - props.width / 2}px, ${
                transform.y - props.height / 2
              }px, 0)`
            : `translate(-50%, -50%)`,
        left: props.left,
        top: props.top,
      }}
      {...listeners}
      {...attributes}
    >
      {props.children}
    </div>
  );
}

export default Draggable;
